/* eslint-disable react/forbid-prop-types */
import React from "react";
import { H2, Paragraph, Link, Text } from "components/core/Typography";
import PropTypes from "prop-types";
import "./TermsAndConditions.scss";

const HeadingPoints = ({ heading, paragraphs, points }) => (
	<>
		{heading && <H2>{heading}</H2>}
		{paragraphs?.map((item) => (
			<>
				{item.haveLink && (
					<Paragraph>
						{item.haveLink.contentBefore}
						<Link
							hover
							size="standard"
							color="blue"
							underline
							href={item.haveLink.link}
						>
							{item.haveLink.linkText}
						</Link>
						{item.haveLink.contentAfter}
					</Paragraph>
				)}
				{item.simpleText && <Paragraph>{item.simpleText}</Paragraph>}
				{item.mixText && (
					<>
						<Text weight="bold">{item.mixText.bold}</Text>
						<Paragraph>{item.mixText.simple}</Paragraph>
					</>
				)}
			</>
		))}

		<ul className="alphabatic-list">
			{points?.map((point) => (
				<Paragraph>
					{!point.haveLink && !point.haveInnerPoints && (
						<li>{point}</li>
					)}
					{point.haveLink && (
						<li>
							<span>
								{point.haveLink.contentBefore}
								<Link
									hover
									size="standard"
									color="blue"
									underline
									href={point.haveLink.link}
								>
									{point.haveLink.linkText}
								</Link>
								{point.haveLink.contentAfter}
							</span>
						</li>
					)}
					{point.haveInnerPoints && (
						<>
							<li>{point.haveInnerPoints.mainPoint}</li>
							<ul className="roman-list">
								{point.haveInnerPoints.innerPoints?.map((p) => (
									<li>{p}</li>
								))}
							</ul>
						</>
					)}
				</Paragraph>
			))}
		</ul>
	</>
);

HeadingPoints.propTypes = {
	heading: PropTypes.string,
	paragraphs: PropTypes.array,
	points: PropTypes.array
};

export default HeadingPoints;
